import { render } from "./PlatformFeatureComparison.vue?vue&type=template&id=f865fa1e"
import script from "./PlatformFeatureComparison.vue?vue&type=script&lang=js"
export * from "./PlatformFeatureComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__